import { Component, OnInit } from '@angular/core';
import { Modal } from 'src/app/models/Modal.model';
import { ModalNames } from '../Modal';

export type RecaptchaModalInputs = {
  imageUrl: string;
  imageAlt: string;
  correctCode: string;
}

@Component({
    templateUrl: './recaptcha.modal.html',
    styleUrls: ['./recaptcha.model.scss']
})
export class RecaptchaModalComponent extends Modal {

    public answer: string;

    public image: string;
    public imageAlt: string;
    public correctCode: string;

    onInjectInputs({ imageUrl, imageAlt, correctCode }: RecaptchaModalInputs): void {
        this.image = imageUrl;
        this.imageAlt = imageAlt;
        this.correctCode = correctCode;
    }

    getCloseResult(): any {
        return { correct: this.answer === this.correctCode };
    }
  
    getName(): ModalNames {
        return ModalNames.RECAPTCHA;
    }
}